import _styled from "styled-components";
import React, { useMemo } from 'react';
import Help from '../../help/Help';
import FieldGroupContext from '../FieldGroupContext';
import { useFormContext } from '../FormContext';
import { groupHelp } from '../Form.style';
import Group from '../group/Group';
import { getError } from '../utils';
const RadioGroup = _ref => {
  let {
    name,
    children,
    ...rest
  } = _ref;
  const {
    submitCount,
    touched,
    errors
  } = useFormContext();
  const fieldGroupContext = useMemo(() => ({
    showGroupError: true
  }), []);
  const error = getError(submitCount > 0, name, touched, errors);
  return /*#__PURE__*/React.createElement(FieldGroupContext.Provider, {
    value: fieldGroupContext
  }, /*#__PURE__*/React.createElement(Group, rest, children, error && /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(Help, {
    error: !!error
  }, error))));
};
export default RadioGroup;
var _StyledDiv = _styled("div").withConfig({
  displayName: "RadioGroup___StyledDiv",
  componentId: "sc-4j6jsr-0"
})(["", ""], groupHelp);
//# sourceMappingURL=RadioGroup.js.map